/**
 * Object.entries but preserves the types of the keys and values
 */
export const objectEntries = (r) => Object.entries(r);
